// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"ResizingImage-module--imageContainer--dbb481","image":"ResizingImage-module--image--23a8d7"};